module.exports = __webpack_public_path__ + "img/blue-loader.f4ebc0f6.svg";